import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { is, map } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { selectors } from 'store/newDocumentStore';

import Tile from '../components/Tile';
import { documentIsBeingEdited, getLatestFinishedCommitData } from 'lib/documentHandling';

const mapSummaryDocuments = d => ({ ...d, ...getLatestFinishedCommitData(d) });
const mapDocs = map(mapSummaryDocuments);

const makeLocaleMessage =
  fm =>
  (id, values = {}) =>
    is(String, id) ? fm({ id }, values) : null;

class SummaryLoader extends Component {
  render() {
    const {
      count,
      editing,
      documents,
      intl: { formatMessage },
    } = this.props;
    const localeMessage = makeLocaleMessage(formatMessage);

    const sortedDocs = documents.sort((d1, d2) => d2.createDate - d1.createDate);

    return createElement(Tile, { ...this.props, data: mapDocs(sortedDocs), count, editing, localeMessage });
  }
}

SummaryLoader.propTypes = {
  module: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  count: PropTypes.object,
  editing: PropTypes.bool,
  documents: PropTypes.array,
  intl: intlShape,
};

/**
 * Map summary state from redux data
 * @param {object} state Redux root state
 * @param {object} ownProps Props passed to component
 * @returns {{ count: { [key: string]: number } | null, documents: IDocuments[], editing: boolean }} Summary state
 */
const mapStateToProps = (state, ownProps) => {
  const loadedDocTypes = Array.isArray(ownProps.module) ? ownProps.module : [ownProps.module];
  let documents = [];
  let editing = false;
  let count = {};
  for (const docType of loadedDocTypes) {
    const moduleState = selectors.selectModuleState(docType, state.newDocs);
    if (moduleState && moduleState.documents) {
      documents = documents.concat(moduleState.documents);
      count[docType] = moduleState.documents.length;
      editing = editing || moduleState.documents.some(d => documentIsBeingEdited(d));
    }
  }
  return { count: Object.keys(count).length > 0 ? count : null, documents, editing };
};

// Connect the summary loader to store using react-redux connect middleware
const ConnectedLoader = connect(mapStateToProps)(injectIntl(SummaryLoader));

export default ConnectedLoader;

// An optional helper function for creating summary tiles
export const createSummaryTile = (view, props) => () => createElement(ConnectedLoader, { ...props, view });
